<template>
    <div>
        <loading :show="pageLoading" class="h-100 w-100"/>
        <ValidationObserver ref="observerAttendance" v-slot="{ invalid }">
                <b-table
                    :empty-filtered-text="$t('no_result')"
                    :empty-text="$t('no_result')"
                    bordered
                    striped
                    responsive
                    :items="tableData"
                    :fields="tableFields"
                    show-empty
                    class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">

                    <template #cell(status)="row">
                            <b-form-group
                                v-slot="{ ariaDescribedby }"
                            >
                                <ValidationProvider
                                    :name="`status_${row.index}`"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <div>
                                        <b-form-checkbox
                                            v-for="option in options"
                                            v-model="row.item.status"
                                            :key="option.value"
                                            :value="option.value"
                                            :aria-describedby="ariaDescribedby"
                                            :name="`status_${row.index}`"
                                        >
                                            {{ option.text }}
                                        </b-form-checkbox>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </b-form-group>
                    </template>
                    <template #cell(description)="row">
                        <div v-if="row.item.status==='absent_with_excuse'">
                            <ValidationProvider
                                :name="`description_${row.index}`"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <b-form-textarea
                                    :id="`textarea_${row.index}`"
                                    v-model="row.item.description"
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </template>
                </b-table>
            <ProcessingButton :label="$t('save')" css-class="d-flex justify-content-center" :processing="loading" :disabled="invalid || loading" @click="updateStatus"/>
        </ValidationObserver>
    </div>
</template>
<script>
import ExamScheduleService from "@/services/ExamScheduleService";
import { ValidationProvider } from 'vee-validate';
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import examScheduleService from "@/services/ExamScheduleService";

export default {
    name: 'ObserverShow',
    components: {
        ProcessingButton,
        ValidationProvider
    },
    props:{
      formId:{
          type: Number,
          required: true
      }
    },
    data() {
        return {
            pageLoading:false,
            loading:false,
            tableData: [],
            options:[
                {
                    text:this.$t('absent_without_excuse'),
                    value:'absent_without_excuse'
                },
                {
                    text:this.$t('absent_with_excuse'),
                    value:'absent_with_excuse'
                },

            ],
            tableFields: [
                {
                    key: 'observer_name',
                    label:this.$t('name')
                },
                {
                    key: 'observer_surname',
                    label:this.$t('surname')
                },
                {
                    key: 'classroom_name',
                    label:this.$t('classroom')
                },
                {
                    key: 'status',
                    label:this.$t('status')
                },
                {
                    key: 'description',
                    label:this.$t('description')
                }
           ]
        }
    },
    mounted() {
        this.getObserverInfo();
    },
    methods: {
       async getObserverInfo() {
            try {
                this.pageLoading=true
                const res = await ExamScheduleService.observerStatuses(this.formId)
                this.tableData=res.data.data
            }catch (err){
                this.showErrors(err)
            }finally {
                this.pageLoading=false
            }
        },
        async updateStatus(){
           const isValid =await this.$refs.observerAttendance.validate()
            if (!isValid)return
            let data =[]
            data=this.tableData.map(item=>{
                return {
                    exam_schedule_classroom_id:item.exam_schedule_classroom_id,
                    observer_id:item.observer_id,
                    status:item.status,
                    description:item.status==='absent_with_excuse'?item.description:null
                }
            })
            this.loading=true
            try {
                const res =await examScheduleService.observerAttendanceStatuses(this.formId,{observer_attendances:data})
                this.$toast.success(this.$t('api.' + res.data.message));
                this.$emit('successUpdate')
            }catch (err){
                this.showErrors(err,this.$refs.observerAttendance)

            }finally {
                this.loading=false
            }



        }
    },
}
</script>
